import { PropertyDTO } from './property.dto';

export const propertiesToObject = (input: PropertyDTO[]): any => {
    if (input === null || input === undefined || input.length === 0) {
        return {};
    } else {
        const result = input.reduce((obj, row) => {
            if (row.type === 'class java.util.Date') {
                {
                    const v = new Date(row.value);
                    const res = v.getTime() + v.getTimezoneOffset() * 60 * 1000;

                    obj[row.name] = new Date(res);
                }
            } else {
                // console.log(row.name);
                obj[row.name] = row.value;
            }

            return obj;
        }, {});
        return result;
    }
};

export const objectToProperties = (input: any): PropertyDTO[] => {
    if (input === null || input === undefined) {
        return [];
    } else {
        let result = [];
        const keys = Object.keys(input);
        for (const key of keys) {
            let v = input[key];
            if (v instanceof Date) {
                const vD = v as Date;

                // console.log('B', key, v);
                const res = (v.getTime() -
                    v.getTimezoneOffset() * 60 * 1000) as unknown;
                // console.log('A', key, res, new Date(res as number));
                const prop = {
                    name: key,
                    value: res,
                } as PropertyDTO;
                result = [prop, ...result];
            } else {
                const prop = { name: key, value: v } as PropertyDTO;
                result = [prop, ...result];
            }
        }

        return result;
    }
};

export interface IPropertyContainer {
    propertiesObj: any;
    properties: PropertyDTO[];
}

export function mapProperties<T>(obj: T): T {
    const objUnknown = (obj as unknown) as IPropertyContainer;
    objUnknown.propertiesObj = propertiesToObject(objUnknown.properties);
    return obj as T;
}

export function mapPropertiesObj<T>(obj: T): T {
    const objUnknown = (obj as unknown) as IPropertyContainer;
    objUnknown.properties = objectToProperties(objUnknown.propertiesObj);
    delete objUnknown.propertiesObj;
    return obj as T;
}

export function deepCopy(obj) {
    let copy;

    // Handle the 3 simple types, and null or undefined
    if (null == obj || 'object' != typeof obj) {
        return obj;
    }

    // Handle Date
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (let i = 0, len = obj.length; i < len; i++) {
            copy[i] = deepCopy(obj[i]);
        }
        return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (const attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                copy[attr] = deepCopy(obj[attr]);
            }
        }
        return copy;
    }

    throw new Error('Unable to copy obj! Its type isnt supported.');
}
